import { render } from "./ViewFile.vue?vue&type=template&id=7ed6e11c&scoped=true"
import script from "./ViewFile.vue?vue&type=script&lang=js"
export * from "./ViewFile.vue?vue&type=script&lang=js"

import "./ViewFile.vue?vue&type=style&index=0&id=7ed6e11c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed6e11c"]])

export default __exports__